import { cn } from '@change/ds-utils';

import { Link, Text } from '@change/ds-core-ui/next';

import { isSsr } from '@change-corgi/core/ssr';
import { getWindow } from '@change-corgi/core/window';

import { ReportAIIssueLink } from 'src/app/shared/components/ReportAIIssueLink';

import { useProfileCardRedesign } from '../../hooks/useProfileCardRedesign';

export function Description() {
	const {
		data: { descriptionText, descriptionClamped, isDescriptionClampable },
		actions: { handleShowFullTextClick },
	} = useProfileCardRedesign();

	return (
		<>
			<Text
				as="p"
				data-qa="dm-description"
				variant="body"
				className={cn(
					{
						// eslint-disable-next-line @typescript-eslint/naming-convention
						'lg:line-clamp-3': isDescriptionClampable.desktop && descriptionClamped,
						// eslint-disable-next-line @typescript-eslint/naming-convention
						'line-clamp-3': isDescriptionClampable.mobile && descriptionClamped,
					},
					'mt-8 text-content-primary',
				)}
			>
				{descriptionText}
			</Text>

			<Link
				onClick={handleShowFullTextClick}
				variant="secondary"
				data-qa="dm-description-toggle"
				className={cn('mt-1 hidden', {
					// eslint-disable-next-line @typescript-eslint/naming-convention
					'sm:inline-block': isDescriptionClampable.mobile,
					// eslint-disable-next-line @typescript-eslint/naming-convention
					'md:hidden': isDescriptionClampable.mobile && !isDescriptionClampable.desktop,
					// eslint-disable-next-line @typescript-eslint/naming-convention
					'lg:inline-block': isDescriptionClampable.desktop,
				})}
			>
				{descriptionClamped ? 'Show full text' : 'Show less'}
			</Link>

			{descriptionText && (
				<div className="text-surface-accent mt-4" data-qa="dm-description-report-ai-issue">
					{/* This is not a component built with the Tomate-DS. */}
					<ReportAIIssueLink pageUrl={isSsr() ? undefined : getWindow().location.href} type="generic" />
				</div>
			)}
		</>
	);
}
